export default "__VITE_ASSET__ZbJcC1tA__"